import { AppContextProps, useAppContext } from '@app/contexts';
import { UserInfo } from '@app/hooks';

type UsePatronSession = Partial<UserInfo> &
  Pick<AppContextProps, 'patronSession'>;

export const usePatronSession = (): UsePatronSession => {
  const appContext = useAppContext();
  const patronSession = appContext?.patronSession;
  const { externalSystemId } = patronSession?.user ?? {};

  return {
    patronSession,
    externalSystemId,
  };
};
